import { useState } from "react";
import { Sparkles } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { RoomCard } from "../components/RoomCard";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS, track, whatsappLink } from "../lib/site";
import { ArrowUpRight } from "lucide-react";

const FILTERS = ["All", "Deluxe", "Cottage", "Suite"];

export default function Rooms() {
  const { rooms, settings } = useSite();
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? rooms : rooms.filter((room) => room.category === filter);
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[4]}
        eyebrow="Rooms & Suites"
        lines={[<>Eight ways</>, <em>to stay.</em>]}
        lede="Deluxe rooms, village cottages and signature suites — rates include breakfast for two and all taxes. Every room is available on request for your dates."
      />
      <section className="stay-section section-pad" data-testid="rooms-catalogue">
        <Reveal className="filter-row" data-testid="room-filters">
          {FILTERS.map((item) => (
            <button
              key={item}
              className={filter === item ? "filter-chip active" : "filter-chip"}
              onClick={() => setFilter(item)}
              data-testid={`filter-${item.toLowerCase()}`}
            >
              {item}
            </button>
          ))}
        </Reveal>
        <div className="room-grid">
          {shown.map((room, i) => <RoomCard room={room} index={i} key={room.id} />)}
        </div>
        <Reveal className="catalogue-note">
          <Sparkles size={18} />
          <span><strong>Your room, your rhythm.</strong> Rates include taxes and breakfast for two — every room is available when you book direct.</span>
          <a href={whatsappLink("Hello Madhubhan Resort & Spa, I have a question about your rooms.", settings.whatsapp)} target="_blank" rel="noreferrer" onClick={() => track("whatsapp_click", { location: "rooms_page" })} data-testid="rooms-whatsapp-link">
            Ask on WhatsApp <ArrowUpRight size={15} />
          </a>
        </Reveal>
        {Array.isArray(settings.facilities) && settings.facilities.length > 0 && (
          <Reveal className="facilities-strip" data-testid="facilities-strip">
            {settings.facilities.map((facility) => <span key={facility}>{facility}</span>)}
          </Reveal>
        )}
      </section>
    </main>
  );
}
